import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.js";

export function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!user) return null;

  const initials = user.username?.charAt(0).toUpperCase() ?? "?";

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-full px-3 py-1.5 hover:bg-white/10 transition-colors"
      >
        {user.avatar ? (
          <img
            src={user.avatar}
            alt={user.username}
            className="w-8 h-8 rounded-full object-cover"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-brand-red flex items-center justify-center text-sm font-bold text-white">
            {initials}
          </div>
        )}
        <span className="text-sm font-medium text-gray-200 hidden sm:inline">
          {user.username}
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 rounded-lg bg-surface-card border border-white/10 shadow-xl py-1 z-50">
          <Link
            to="/collection"
            onClick={() => setOpen(false)}
            className="block px-4 py-2 text-sm text-gray-200 hover:bg-white/10 transition-colors"
          >
            My Collection
          </Link>
          <Link
            to="/wishlist"
            onClick={() => setOpen(false)}
            className="block px-4 py-2 text-sm text-gray-200 hover:bg-white/10 transition-colors"
          >
            Wishlist
          </Link>
          <Link
            to="/marketplace"
            onClick={() => setOpen(false)}
            className="block px-4 py-2 text-sm text-gray-200 hover:bg-white/10 transition-colors"
          >
            Marketplace
          </Link>
          <Link
            to="/settings"
            onClick={() => setOpen(false)}
            className="block px-4 py-2 text-sm text-gray-200 hover:bg-white/10 transition-colors"
          >
            Settings
          </Link>
          <div className="border-t border-white/10 my-1" />
          <button
            onClick={() => {
              setOpen(false);
              logout();
            }}
            className="block w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-white/10 transition-colors"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
